import { BiomassLevel, BiomassUnit, CropCategory, CropDisease, CropId, CropMaltingOption, CropProtectionStatus, CropPurpose, CropResidue, CropStyleFillPattern, ExternalAppId, FertiliserAppUnit, FertiliserLiquidUnit, FieldAreaType, GenericPlanUnitId, GrassCuts, GrassManagement, GrassManagementEngland, GrassManagementScotland, GridSampleAnalysisType, GrowingSeasonLength, HeadlandIncreaseUnit, HoldingNotificationId, ImportHistoryProvider, ImportHistoryType, LayerTypeGroupId, LayerTypeId, LayerTypeSubgroupId, LayerValueType, LayerZoneTypeId, ManureAppMethod, ManureUnit, MapGeometryType, MapImportFileFormat, MapImportKnownFileType, MapRegularShapeType, MapScope, NitrogenAnalysisType, NitrogenSnsMethod, NLeafAnalysis, NtrReqConfigMode, NutrientGroup, NutrientType, OrderInvoice, PlanType, ProductAppInput, RegionId, SatImageType, SoilAnalysisImportStep, SoilAnalysisLayerSubtype, SoilAnalysisProvider, SoilAnalysisType, SoilCategory, SoilP2O5Method, SoilTypeId, SprayQuality, SsmClassId, StockType, SubsoilTypeId, SyncEventStatus, TaskStatus, TerraMapLayerType, TradingContractType, YieldLayerSubtype, YieldPotentialCategory } from "../shared/generated/enums";
import { PrescriptionType } from "../shared/prescriptions/types";

export const models = {

    RegionId,
    HoldingNotificationId,

    CropId,
    FieldAreaType,
    CropPurpose,
    CropProtectionStatus,
    CropMaltingOption,
    CropCategory,
    CropResidue,
    CropStyleFillPattern,

    GrowingSeasonLength,
    BiomassLevel,
    GrassManagement,
    GrassManagementEngland,
    GrassManagementScotland,
    GrassCuts,
    NLeafAnalysis,

    SoilTypeId,
    SubsoilTypeId,
    SoilCategory,

    PlanType,

    LayerTypeId,
    LayerTypeGroupId,
    LayerTypeSubgroupId,
    LayerValueType,
    LayerZoneTypeId,

    YieldLayerSubtype,
    SoilAnalysisLayerSubtype,
    TerraMapLayerType,

    MapGeometryType,
    MapScope,
    MapRegularShapeType,

    GenericPlanUnitId,

    PrescriptionType,

    SatImageType,

    StockType,

    BiomassUnit,

    FertiliserLiquidUnit,
    FertiliserAppUnit,
    ProductAppInput,
    ManureAppMethod,
    NitrogenSnsMethod,
    ManureUnit,

    NutrientGroup,
    NutrientType,
    NtrReqConfigMode,

    OrderInvoice,
    NitrogenAnalysisType,
    SoilP2O5Method,
    SsmClassId,
    SoilAnalysisType,

    HeadlandIncreaseUnit,

    SprayQuality,

    TradingContractType,

    YieldPotentialCategory,

    CropDisease,

    ExternalAppId,
    SyncEventStatus,

    MapImportKnownFileType,
    ImportHistoryProvider,
    SoilAnalysisProvider,
    SoilAnalysisImportStep,
    ImportHistoryType,
    GridSampleAnalysisType,
    MapImportFileFormat,
    TaskStatus


}